<template>
<div>
    <bar-manut 
        single-entity="Contador" 
        plural-entity="Contadores" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>

    <br>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="contador.codcontador" :metadata="metadata.contador.codcontador" type="text" col="2" :disabled="true"></form-field>
                <form-field v-model="contador.nome" type="text" col="4" :metadata="metadata.contador.nome" 
                    name="nome" :v-errors="errors" v-validate="metadata.contador.nome.validator"></form-field>
                <form-field v-model="contador.cnpj" type="cnpj" col="2" :metadata="metadata.contador.cnpj" 
                    name="cnpj" :v-errors="errors" v-validate="metadata.contador.cnpj.validator"></form-field>
                <form-field v-model="contador.cpf" type="number" col="2" :metadata="metadata.contador.cpf" 
                    name="cpf" :v-errors="errors" v-validate="metadata.contador.cpf.validator"></form-field>
                <form-field v-model="contador.crc" type="text" col="2" :metadata="metadata.contador.crc" 
                    name="crc" :v-errors="errors" v-validate="metadata.contador.crc.validator"></form-field>
            </div>
            <div class="row">
                <form-field v-model="contador.cep" type="cep" col="2" :metadata="metadata.contador.cep" 
                    name="cep" :v-errors="errors" v-validate="metadata.contador.cep.validator" @update="updateCep"></form-field>
                <form-field v-model="contador.ende" type="text" col="4" :metadata="metadata.contador.ende" 
                    name="ende" :v-errors="errors" v-validate="metadata.contador.ende.validator"></form-field>
                <form-field v-model="contador.endenr" type="text" col="2" :metadata="metadata.contador.endenr" 
                    name="endenr" :v-errors="errors" v-validate="metadata.contador.endenr.validator"></form-field>
                <form-field v-model="contador.endecomp" type="text" col="4" :metadata="metadata.contador.endecomp" 
                    name="endecomp" :v-errors="errors" v-validate="metadata.contador.endecomp.validator"></form-field>
                <form-field v-model="contador.uf" type="select2" col="3" :metadata="metadata.contador.uf"
                    name="uf" :v-errors="errors" v-validate="metadata.contador.uf.validator"></form-field>
                <form-field v-model="contador.codmun" type="select2" col="3" :metadata="metadata.contador.codmun"
                    name="codmun" :v-errors="errors" v-validate="metadata.contador.codmun.validator"
                    :select2="{entity: 'mun/uf/' + contador.uf, minlength: 2}"></form-field>
                <form-field v-model="contador.fone" type="fone" col="2" :metadata="metadata.contador.fone" 
                    name="fone" :v-errors="errors" v-validate="metadata.contador.fone.validator"></form-field>
                <form-field v-model="contador.email" type="email" col="4" :metadata="metadata.contador.email" 
                    name="email" :v-errors="errors" v-validate="metadata.contador.email.validator"></form-field>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            contador: {...this.$store.getters.getEntities.contador},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        updateCep () {
            //CARREGA INFORMACOES DO CEP
            this.contador.ende = SysVars.endereco.logradouro
            this.contador.bairro = SysVars.endereco.bairro
            this.contador.codmun = SysVars.endereco.ibge
            this.contador.uf = SysVars.endereco.uf
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadContador', { id: this.index } )
            if (this.$store.getters.getContador) {
                this.contador = {...this.$store.getters.getContador}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/contador/' + this.contador.codcontador

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/contador/'
            var sendData = {}

            sendData = { contador: this.contador }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.uf = 'SP'
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/contador-form.vue